import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import InputMask from "react-input-mask";
import { PhoneController } from "@/app/core/base/controllers/PhoneController";
import Storage from "@/app/core/util/Storage";
import OnDataChange from "@/app/core/util/helpers/HandleChange";
import { toast } from "react-toastify";
import { Message } from "@/app/core/util/messages/GeralMessages";
import { useEffect } from "react";
import CurrencyFormat from "react-currency-format";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import HsCodeModal from "../regulation/HsCodeModal";
import { Typeahead } from "react-bootstrap-typeahead";
import { Countries, CurrencyConverter } from "@/app/core/util/helpers/MoneyHelper";
import { HsCodeController } from "@/app/core/base/controllers/HsCodeController";
import { Autocomplete } from "@/app/core/util/helpers/AutocompleteHelper";

export default function BoxModal({ show, onHide, register, update, selected, isNational, boxName }) {
    const userData = Storage.getUserData();
    const [data, setData] = useState({
        currency: CurrencyConverter(Storage.getCurrency()),
    });
    const [hsCode, setHsCode] = useState([]);
    const [countryResults, setCountryResults] = useState([]);
    const [hsResults, setHsCodeResults] = useState([]);
    const [query, setQuery] = useState("");
    const [showModal, setShowModal] = useState(false);
    const [national, setNational] = useState(false);

    useEffect(() => {
        if (selected != undefined && selected.quantity != undefined) {
            let old = selected;
            old.unit_value = selected.unitValue;
            setData(selected);
        } else {
            setData({
                currency: CurrencyConverter(Storage.getCurrency()),
            });
        }
        if (show == true) {
            loadHsCodes()
        } else {
            setData({
                currency: CurrencyConverter(Storage.getCurrency()),
            })
        }
        console.log("Dados", selected)
    }, [selected, show])

    useEffect(() => {
        checkDelivery()
    }, [isNational])

    function checkDelivery() {
        console.log("Mudou alguma coisa", isNational);
        if (isNational == true) {
            setNational(true);
        } else {
            setNational(false);
        }
    }

    function loadHsCodes() {
        HsCodeController.List(res => setHsCode(res))
    }

    function save(e) {
        if (e != undefined) {
            e.preventDefault();
        }
        let message = "Faltou preencher: ";
        let error = false;
        if (data.name == undefined || data.name == "") {
            error = true;
            message += " Nome;";
        }
        if (national != true && (data.hscode == undefined || data.hscode == "")) {
            error = true;
            message += " HSCODE;";
        }
        if (data.quantity == undefined || data.quantity == "") {
            error = true;
            message += " Quantidade.";
        }
        if (data.weight == undefined || data.weight == "") {
            error = true;
            message += " Peso;";
        }
        if (data.unit_value == undefined || data.unit_value == "") {
            error = true;
            message += " Preço; ";
        }

        if (error) {
            toast.error(message);
        } else {
            if (data.id == undefined) {
                register(data);
                console.log("Adicionar", data)
            } else {
                console.log("Atualizar", data)
                update(data);
            }
            setData({});
        }
    }

    function handleChange(evt, type) {
        let infos = OnDataChange(data, evt, type);
        if (evt.target.name == "unitValue") {
            infos.unit_value = infos.unitValue;
        }
        console.log("Estamos alterando", infos);
        if (evt.target.name == "country_code") {
            infos.countryCode = evt.target.value;
        }
        setData(infos);
        if (evt.target.name == "country_code") {
            setCountryResults(autocomplete(evt.target.value))
        }
        if (evt.target.name == "hscode") {
            setHsCodeResults(autocompleteCode(evt.target.value))
        }
    }

    function autocomplete(value) {
        let countries_to_show = [];
        let countries_to_show2 = [];

        if (value.length > 0) {
            countries_to_show = Autocomplete(value, Countries, "Term");
            return countries_to_show;
        } else {
            countries_to_show = [];
            return [];
        }
    }

    function autocompleteCode(value) {
        let codes_to_show = [];
        let codes_to_show2 = [];

        if (value.length > 0) {
            codes_to_show = Autocomplete(value, hsCode, "hscode");
            codes_to_show2 = Autocomplete(value, hsCode, "name");
            return [...codes_to_show, ...codes_to_show2];
        } else {
            codes_to_show = [];
            return [];
        }
    }

    return (
        <Modal
            title="Adicionar item"
            show={show}
            onHide={onHide}
            onSubmit={() => save()}>
            <form onSubmit={e => save(e)} autoComplete="off">
                <div className="block-header">
                    <div className="block-title">
                        <b className="text-warning">
                            Caixa: {boxName}
                        </b>
                    </div>
                    <div className="block-tools">
                        {national != true ?
                            <button className="btn btn-dual" onClick={() => setShowModal(true)}>
                                <i className="si si-question" /> Não sabe o que HSCODE?
                            </button>
                            : ""}
                    </div>

                </div>
                <div className="block-content">
                    <div className="form-group">
                        <span>*Nome</span>
                        <input className="form-control" name="name" value={data && data.name} onChange={evt => handleChange(evt)} />
                    </div>
                    {national != true ?
                        <div className="form-group">
                            <span>Descrição do item (Em inglês)</span>
                            <input className="form-control" name="description" value={data && data.description} onChange={evt => handleChange(evt)} />
                        </div>
                        : ""}


                    {national != true ?
                        <div className="form-group">
                            <span>HSCODE</span>
                            <input
                                name={"hscode"}
                                placeholder="Selecionar"
                                className="form-control"
                                key={`hscode`}
                                value={data && data.hscode}
                                // value={data && data.hscode}
                                onChange={(evt) => handleChange(evt)} />
                            <ul
                                style={hsResults && hsResults.length > 0 ? {
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    position: "fixed",
                                    overflow: "auto",
                                    marginTop: 10,
                                    width: "30%",
                                    zIndex: 999999,
                                    maxHeight: "300px", // TODO: don't cheat, let it flow to the bottom
                                } : {
                                    borderRadius: "3px",
                                }}>
                                {hsResults && data && (data.preHscode == undefined || data.preHscode == "") && hsResults.map((item) => {
                                    return (
                                        <li
                                            className="m-3 cursor"
                                            onClick={() => setData({ ...data, hscode: item.hscode }) | setHsCodeResults([])}
                                        >
                                            {`(${item.hscode}) ${item.name}`}
                                        </li>
                                    );
                                })}
                            </ul>
                            {/* <Typeahead
                            options={hsCode}
                            labelKey={(option) => `(${option.hscode}) ${option.name}`}
                            onSearch={(q) => setQuery(q)}
                            name="hscode"
                            placeholder="Selecionar"
                            defaultInputValue={data && data.preHscode}
                            value={data && data.preHscode}
                            onChange={(selected) => {
                                if (selected[0] != undefined && selected != null) {
                                    if (selected[0].hscode != "outros") {
                                        handleChange({ target: { value: selected[0].hscode, name: "hscode" } });
                                    } else {
                                        handleChange({ target: { value: selected[0].hscode, name: "preHscode" } });
                                    }
                                }
                            }} /> */}
                        </div>
                        : ""}
                    {/* {data && data.preHscode == "outros" ?
                        <div className="form-group">
                            <span>Qual o HSCODE do produto?</span>
                            <input className="form-control" max={6} name="hscode" value={data && data.hscode} onChange={evt => handleChange(evt)} />
                        </div>
                        : ""} */}
                    <div className="form-group">
                        <span>*Quantidade</span>
                        <input type="number" className="form-control" name="quantity" value={data && data.quantity} onChange={evt => handleChange(evt, FieldTypeObj.Number)} />
                    </div>
                    <div className="form-group">
                        <span>*Peso (Kg)</span>
                        <input type="number" className="form-control" name="weight" value={data && data.weight} onChange={evt => handleChange(evt, FieldTypeObj.Decimal)} />
                    </div>
                    <div className="form-group">
                        <span>*Qual é o valor do item?
                            <br />
                            <small>O item será assegurado no valor definido por você logo abaixo.</small>
                        </span>
                        <input
                            className={`form-control`}
                            name="unitValue"
                            type="number"
                            value={data.unitValue}
                            onChange={evt => handleChange(evt, FieldTypeObj.Currency)} />
                    </div>
                    {national != true ?
                        <div className="form-group">
                            <span>*País do produto</span>
                            <input
                                name="country_code"
                                placeholder="Selecionar"
                                className="form-control"
                                key={`country-origin`}
                                defaultInputValue={data && data.country_code}
                                value={data && data.country_code}
                                onChange={(evt) => handleChange(evt)} />

                            <ul
                                style={countryResults && countryResults.length > 0 ? {
                                    borderRadius: "3px",
                                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                                    background: "rgba(255, 255, 255, 0.9)",
                                    padding: "2px 0",
                                    fontSize: "90%",
                                    position: "fixed",
                                    overflow: "auto",
                                    marginTop: 10,
                                    width: "30%",
                                    zIndex: 999999,
                                    maxHeight: "300px", // TODO: don't cheat, let it flow to the bottom
                                } : {
                                    borderRadius: "3px",
                                }}>
                                {countryResults && countryResults.map((item) => {
                                    return (
                                        <li
                                            className="m-3 cursor"
                                            onClick={() => setData({ ...data, country_code: item.Code, countryCode: item.Code }) | setCountryResults([])}
                                        >
                                            {`(${item.Code}) ${item.Name}`}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        : ""}
                </div>
            </form>
            <HsCodeModal
                show={showModal}
                onHide={() => setShowModal(false)}
            />
        </Modal>
    );
}
